module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xm-top-navbar"
  }, [_c('div', [_c('b-navbar', {
    staticClass: "navbar-dark",
    attrs: {
      "fixed": "top",
      "toggleable": "lg"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": _vm.base
    }
  }, [_c('img', {
    class: {
      'xmBrand': _vm.isSignup
    },
    attrs: {
      "src": _vm.brandUrl,
      "alt": "XMission"
    }
  })]), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "XMMainNav",
      "aria-controls": "XMMainNav",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "XMMainNav",
      "is-nav": ""
    }
  }, [_c('b-navbar-nav', {
    staticClass: "mr-auto"
  }, [_c('b-nav-item', [_c('b-nav-item-dropdown', {
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-labelledby": "businessMenu",
      "no-caret": "",
      "text": "Business",
      "menu-class": ['submenu-business', 'businessMenu']
    }
  }, [_c('b-dropdown-header', [_vm._v("Internet Connections")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/xmission-business-fiber')
      }
    }
  }, [_vm._v("XMission Business Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_utopia')
      }
    }
  }, [_vm._v("·\t  Business UTOPIA")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_bountiful')
      }
    }
  }, [_vm._v("·\t  Bountiful Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_lehi')
      }
    }
  }, [_vm._v("·\t  Lehi Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_southern_ute')
      }
    }
  }, [_vm._v("·\t  Southern Ute")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_yellowstone')
      }
    }
  }, [_vm._v("·\t  Yellowstone")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/xwi-smartsmb')
      }
    }
  }, [_vm._v("XWi Smart SMB")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_connectivity')
      }
    }
  }, [_vm._v("Other Connectivity")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Domain & Hosting Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/domains')
      }
    }
  }, [_vm._v("Domain Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/web_hosting')
      }
    }
  }, [_vm._v("Shared Hosting")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/cloud_hosting')
      }
    }
  }, [_vm._v("Managed Cloud Hosting")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/vps')
      }
    }
  }, [_vm._v("Unmanaged Cloud Hosting")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/colocation')
      }
    }
  }, [_vm._v("Colocation")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/ssl')
      }
    }
  }, [_vm._v("SSL Certificates")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Email & Collaboration Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/email_collaboration')
      }
    }
  }, [_vm._v("Hosted Zimbra Email")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/licensing')
      }
    }
  }, [_vm._v("Zimbra Licensing")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/reseller')
      }
    }
  }, [_vm._v("Private Label & Reseller")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Phone & Professional Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_phone')
      }
    }
  }, [_vm._v("Business Phone Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/professional_services')
      }
    }
  }, [_vm._v("Professional Services")])], 1)], 1), _vm._v(" "), _c('b-nav-item', [_c('b-nav-item-dropdown', {
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-labelledby": "residentialMenu",
      "no-caret": "",
      "text": "Residential",
      "href": "#",
      "menu-class": ['residentialMenu', 'submenu-residential']
    }
  }, [_c('b-dropdown-header', [_vm._v("Internet Connections")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/utopia')
      }
    }
  }, [_vm._v("UTOPIA")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/yellowstone_fiber')
      }
    }
  }, [_vm._v("Yellowstone Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/xmission-fiber-bountiful')
      }
    }
  }, [_vm._v("Bountiful Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/lehi')
      }
    }
  }, [_vm._v("Lehi Fiber")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Phone Service")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/voice')
      }
    }
  }, [_vm._v("Voice")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Domain & Hosting Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/domains')
      }
    }
  }, [_vm._v("Domain Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/web_hosting')
      }
    }
  }, [_vm._v("Shared Hosting")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Email")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/personal_email')
      }
    }
  }, [_vm._v("Personal Premium Email")])], 1)], 1), _vm._v(" "), _c('b-nav-item', [_c('b-nav-item-dropdown', {
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-labelledby": "aboutMenu",
      "no-caret": "",
      "text": "About",
      "href": "#",
      "menu-class": "aboutMenu"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/contact')
      }
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/blog')
      }
    }
  }, [_vm._v("Blog")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/our_story')
      }
    }
  }, [_vm._v("Our Story")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/our_network')
      }
    }
  }, [_vm._v("Our Network")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/community')
      }
    }
  }, [_vm._v("Community")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/environment')
      }
    }
  }, [_vm._v("Environment")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/jobs')
      }
    }
  }, [_vm._v("Jobs")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/legal')
      }
    }
  }, [_vm._v("Legal")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/media')
      }
    }
  }, [_vm._v("Media")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/statistics')
      }
    }
  }, [_vm._v("Statistics")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/transparency')
      }
    }
  }, [_vm._v("Transparency")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/privacy-pledge')
      }
    }
  }, [_vm._v("Privacy Pledge")])], 1)], 1), _vm._v(" "), _c('b-nav-item', [_c('b-nav-item-dropdown', {
    attrs: {
      "aria-labelledby": "supportMenu",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "no-caret": "",
      "text": "Support",
      "href": "#",
      "menu-class": "supportMenu"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/support')
      }
    }
  }, [_vm._v("Resource Center")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/contact')
      }
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/livesupport')
      }
    }
  }, [_vm._v("Live Support")])], 1)], 1)], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.search-xmission-modal",
      modifiers: {
        "search-xmission-modal": true
      }
    }],
    staticClass: "btn btn-outline-success",
    attrs: {
      "type": "button",
      "id": "search-button"
    }
  }, [_c('i', {
    staticClass: "bi bi-search"
  })]), _vm._v(" "), (!_vm.isLoggedIn) ? _c('a', {
    staticClass: "btn btn-outline-danger",
    attrs: {
      "href": "/login"
    }
  }, [_c('b', [_vm._v("login")])]) : _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "/control",
      "id": "CtlUserTab"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.username) + "\n          "), _c('small', [_vm._v("logged in")])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Search XMission",
      "id": "search-xmission-modal",
      "hide-footer": ""
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    model: {
      value: (_vm.search_query),
      callback: function($$v) {
        _vm.search_query = $$v
      },
      expression: "search_query"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("\n            Go\n          ")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f47bfba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopNavbar.vue
// module id = 1328
// module chunks = 16